import {
  getIconSizeProps,
  type IconProps,
} from '@packages/webshop-design-system';

/** Trenitalia France seat pictogram (BR-57773). */
export const TifSeatIcon = (props: IconProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="30 28 38 37"
    fill="none"
    {...getIconSizeProps(12, 12, props)}
  >
    <g opacity={0.7}>
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit={10}
        d="M56.17,47.84h-13.43c-1.88,0-3.43,1.53-3.43,3.43s1.55,3.43,3.43,3.43h13.43c1.9,0,3.43-1.55,3.43-3.43s-1.53-3.43-3.43-3.43ZM56.17,53.03h-13.43c-.96,0-1.76-.8-1.76-1.76s.8-1.76,1.76-1.76h13.43c.99,0,1.79.78,1.79,1.76s-.8,1.76-1.79,1.76Z"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit={10}
        d="M65.98,41.55c-.68-.87-2.06-1.34-3.52-1.15-.11.01-.22.04-.33.06-.99-6.21-6.44-11.13-12.54-11.15h-.03c-3.73,0-7.23,1.43-9.61,3.92-1.9,1.98-2.92,4.48-3,7.26-.16-.04-.33-.07-.5-.09-1.44-.18-2.84.28-3.52,1.15-1.23,1.57-1.4,2.66-.85,5.53.51,2.7,3.65,14.98,3.77,15.49.03.15.4,1.44,2.49,1.44,1.19,0,1.85-.42,2.2-.8h17.8c.35.37,1.01.8,2.2.8,2.09,0,2.46-1.29,2.49-1.42.13-.52,3.26-12.8,3.78-15.5.55-2.87.38-3.96-.85-5.53ZM65.19,46.77c-.51,2.65-3.72,15.27-3.73,15.33-.04.07-.28.24-.9.24-.76,0-.98-.25-.99-.25,0,0,0,0,0,0-.12-.33-.43-.55-.78-.55h-18.65c-.35,0-.64.16-.76.49,0,0-.19.31-1.02.31-.62,0-.85-.17-.87-.17-.03-.13-3.25-12.75-3.76-15.4-.5-2.61-.28-3.16.53-4.19.27-.35,1.04-.63,2.01-.53.51.06,1.74.33,2.3,1.54.19.41.42,1.27.42,3.03,0,.46.37.83.83.83s.83-.37.83-.83c0-1.67-.19-2.89-.57-3.72-.32-.69-.83-1.28-1.46-1.71-.08-2.62.79-4.98,2.55-6.81,2.04-2.13,5.18-3.4,8.41-3.4h.02c5.41.01,10.23,4.49,10.95,10.07-.74.44-1.34,1.07-1.7,1.85-.39.83-.57,2.05-.57,3.72,0,.46.37.83.83.83s.83-.37.83-.83c0-1.75.23-2.61.42-3.03.56-1.21,1.8-1.48,2.3-1.54.95-.11,1.74.18,2.01.53.81,1.03,1.03,1.58.53,4.19Z"
      />
    </g>
  </svg>
);
